import React, { useEffect } from "react";

type ModalProps = {
  open: boolean;
  title: string;
  eyebrow?: string;
  onClose: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
  size?: "md" | "lg";
};

export function Modal({ open, title, eyebrow, onClose, children, footer, size = "md" }: ModalProps) {
  useEffect(() => {
    if (!open) return;
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape") onClose();
    }
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="oht-modal-backdrop"
      role="presentation"
      onClick={onClose}
    >
      <div
        className={`oht-modal oht-modal--${size}`}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(e) => e.stopPropagation()}
      >
        <header className="oht-modal-header">
          <div>
            {eyebrow ? <div className="oht-modal-eyebrow">{eyebrow}</div> : null}
            <h2 className="oht-modal-title">{title}</h2>
          </div>
          <button
            type="button"
            className="oht-modal-close"
            aria-label="Close"
            onClick={onClose}
          >
            ×
          </button>
        </header>
        <div className="oht-modal-body">{children}</div>
        {footer ? <footer className="oht-modal-footer">{footer}</footer> : null}
      </div>
    </div>
  );
}
